import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { SortedGameWord } from './Word'

interface SortedGameBoardProps {
  id: string
  items: string[]
  ignoreOrder?: boolean
  disabled?: boolean
}

export function SortedGameBoard({
  id,
  items,
  ignoreOrder,
  disabled = false
}: SortedGameBoardProps) {
  const {
    active,
    attributes,
    isDragging,
    listeners,
    over,
    setNodeRef,
    transition,
    transform
  } = useSortable({
    id,
    data: {
      type: 'container',
      children: items
    },
    disabled
  })

  const isOverContainer = over
    ? (id === over.id && active?.data.current?.type !== 'container') ||
      items.includes(over.id as string)
    : false

  let classes =
    'flex flex-row flex-wrap items-start content-start gap-4 w-full flex-grow min-h-[100px]'
  if (id === 'correctWords') {
    classes += ` card w-full rounded-2xl min-h-[125px] flex flex-row flex-wrap items-start content-start gap-3 p-4 lg:p-6 border-2 border-gray-300 flex-shrink-0 ${
      isOverContainer ? 'bg-gray-200' : 'bg-gray-100'
    }`
  }

  return (
    <div
      className={`flex flex-col w-full ${
        id === 'wrongWords' ? 'flex-grow flex-shrink' : 'flex-shrink-0'
      }`}
    >
      <SortableContext
        id={id}
        items={items}
        strategy={verticalListSortingStrategy}
        disabled={disabled}
      >
        <div
          id={id}
          ref={setNodeRef}
          style={{
            transition,
            transform: CSS.Translate.toString(transform),
            opacity: isDragging ? 0.5 : undefined
          }}
          {...listeners}
          {...attributes}
          className={classes}
        >
          {items.map(itemId => (
            <SortedGameWord
              key={itemId}
              id={itemId}
              text={itemId}
              disabled={disabled}
            />
          ))}
        </div>
      </SortableContext>
      {id === 'correctWords' && (
        <span className="text-gray-700 text-sm font-medium block w-full text-left bg-jacaranda/20 pt-5 px-4 pb-2 rounded-b-2xl -mt-4 z-[-1]">
          {`Arraste as expressões corretas para esta área ${
            ignoreOrder ? 'em qualquer ordem' : 'na ordem correta'
          }`}
        </span>
      )}
    </div>
  )
}
